import { render, staticRenderFns } from "./ProductEditRelated.vue?vue&type=template&id=3aaed6b4&"
import script from "./ProductEditRelated.vue?vue&type=script&lang=js&"
export * from "./ProductEditRelated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports